import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsShop} from "react-icons/bs";
import {FaCubes} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";

import {useNavigate} from "react-router-dom";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {BiSolidSelectMultiple} from "react-icons/bi";
import {LiaUserEditSolid} from "react-icons/lia";

const currencyFormat = Intl.NumberFormat('en-US');

function VendorProductsBatchEdit() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [user, setUser] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState([]);
    const [vendor, setVendor] = React.useState([]);
    const [cPrice, setCPrice] = React.useState([]);
    const [ePrice, setEPrice] = React.useState([]);
    const [bPrice, setBPrice] = React.useState([]);



    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        API.getUserInfo()
            .then((response) => {

                setUser(response.data.user);
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }

            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
        const params = {
            processFor: 'Suppliers',
            vendor_id: window.localStorage.getItem("vendor"),
            vendor: window.localStorage.getItem("vendor"),
            orderBy: 'id',
            orderType: 'desc',

        }
        API.getVendor(params)
            .then((response) => {
                setIsLoaded(true);
                setVendor(response.data)
            })
            .catch((error) => {
                setTimeout (() => {
                    navigate(`/vendor/select`)
                },400)
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });


    }, []);


/*    React.useEffect(() => {

        if (vendor?.products) {

            let theCPrice = [];
            let theEPrice = [];
            let theBPrice = [];
            vendor.products.forEach((product) => {
                theCPrice[product.id] = product.vendor_price.consumer_price
                theEPrice[product.id] = product.vendor_price.each_price
                theBPrice[product.id] = product.vendor_price.price
            });

            setCPrice(theCPrice)
            setEPrice(theEPrice)
            setBPrice(theBPrice)

        }
    }, [vendor.products]);*/


// پر کردن اولیه (در useEffect)
    React.useEffect(() => {
        if (vendor?.products) {
            const initialPrices = {};
            const initialPrices2 = {};
            const initialPrices3 = {};
            vendor.products.forEach(p => {
                initialPrices[p.id] = p.vendor_price.consumer_price;
                initialPrices2[p.id] = p.vendor_price.each_price;
                initialPrices3[p.id] = p.vendor_price.price;
            });
            setCPrice(initialPrices);
            setEPrice(initialPrices2)
            setBPrice(initialPrices3)
        }
    }, [vendor?.products]);

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }

    const onUpdatePrice = (id, type, price) => {
        const formData = new FormData();
        formData.append('price', price);
        formData.append('type', type);
        formData.append('_method', 'PATCH');
        formData.append('vendor_id', window.localStorage.getItem("vendor"));

        API.updateProductPrice(formData, id)
            .then((response) => {
                toast.success(response.message);
                if (type === "A") {
                   window.location.reload();
                }
            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });


    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="container-fluid  rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end "
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display = 'block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3'/>

                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded " width='30'/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 p-5 ">
                        <div className="row " id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center">
                                        {
                                            isLoaded && user?.vendor?.map (vendor  => {
                                                if(vendor.id === parseInt(window.localStorage.getItem("vendor")) ) {
                                                    return (
                                                        <img src={vendor.cover_photo} alt="Cover" className='w-100 mt-3 company-cover-photo' />
                                                    )
                                                }
                                                return '';
                                            } )
                                        }
                                        <div className='text-primary-color mb-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;

                                            {user.surname}
                                            &nbsp;

                                            (
                                            {
                                                window.localStorage.getItem("vendorTitle")
                                            }
                                            )

                                        </div>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/1`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تازه ثبت شده
                                        {
                                            orderCount > 0 &&  <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    {orderCount}
                                                                </span>
                                        }
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/2`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های جاری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/3`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تمام شده
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         id='active'
                                    >
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/manage`)}
                                    >
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/select`)}
                                    >
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/edit-profile`)}
                                    >
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/reports`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
     <div className="col-12 item "
                                         onClick={() => navigate(`/product-reports`)}

                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش  فروش کالا
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/wallet`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش صورت عملکرد
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={onExitClick}
                                    >
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 pt-md-5 pb-5  main-part mt-md-5 main-part mt-md-5">

                        <div className="row px-2 ">
                            <div className="col-12 page-title text-center pb-4 mb-5 border-bottom fw-bold text-muted">
                               ویرایش دسته ای قیمت کالاها

                            </div>


                            <div className="col-md-6">
                                <div className="alert alert-dark p-2 text-center text-small-3">
                                    با خروج از کادر (زدن TAB)  آن قیمت ذخیره می شود.
                                </div>
                            </div>

                            <div className="col-md-6 text-start">
                                <button className='btn btn-outline-dark  text-small-2 '
                                        onClick={() => navigate(`/products`)}
                                >
                                 بازگشت به مدیریت کالاها
                                </button>
                            </div>
                            <div className="col-12 mt-4 table-responsive">
                                <table className="table text-small-1  table-striped bg-white order-table">
                                    <thead className='text-small-2'>
                                    <tr className="bg-primary-color text-white text-center small-1 ">

                                        <td>
                                            عنوان کالا
                                        </td>
                                        <td>
قیمت مصرف کننده
                                        </td>
                                        <td>
                                         قیمت هر عدد
                                        </td>
                                        <td>
                                         قیمت پایه
                                        </td>

                                    </tr>
                                    </thead>
                                    <tbody className='text-small-1'>

                                    {
                                        isLoaded && vendor.products.map (product => {

                                            return (
                                                <tr className="text-center" style={{cursor:'unset !important'}} key={product.id}

                                                >
                                                    <td>
                                                        {product.name}
                                                        <br/>
                                                        <br/>
                                                        <input type="checkbox" id="isactive" className='text-muted'
                                                               checked={product.is_active}
                                                               onChange={(e) => {
                                                                    onUpdatePrice(product.id, "A", e.target.checked)

                                                               }}
                                                               />
                                                        <label htmlFor="isactive"> فعال است</label><br/>
                                                    </td>
                                                    <td>

                                                    <input
                                                            type="number"
                                                            value={cPrice[product.id] || ''} // هندل کردن حالت undefined
                                                            onChange={(e) => {
                                                                const newValue = e.target.value;
                                                                setCPrice(prev => ({...prev, [product.id]: newValue}));
                                                            }}
                                                            onBlur={(e) => {
                                                                if (parseInt(e.target.value) !== product.vendor_price.consumer_price)
                                                                    onUpdatePrice(product.id, "C", e.target.value)
                                                            }}
                                                            className='w-100 rounded  border-0 py-2 text-start ltr '
                                                        />
                                                        <div className='p-0 mt-1 text-muted text-small-2 text-start'>
                                                            {currencyFormat.format(Math.round(cPrice[product.id] / 10))}
                                                            &nbsp;
                                                            تومان
                                                        </div>
                                                    </td>
                                                    <td>

                                                        <input
                                                            type="number"
                                                            value={ePrice[product.id] || ''} // هندل کردن حالت undefined
                                                            onChange={(e) => {
                                                                const newValue = e.target.value;
                                                                setEPrice(prev => ({...prev, [product.id]: newValue}));
                                                                const newValue2 = e.target.value * product.in_box_count;
                                                                setBPrice(prev => ({...prev, [product.id]: newValue2}));
                                                            }}
                                                            onBlur={(e) => {
                                                                if (e.target.value !== product.vendor_price.each_price)
                                                                onUpdatePrice(product.id, "E", e.target.value)}}
                                                            className='w-100 rounded  border-0 py-2 text-start ltr '
                                                        />
                                                        <div className='p-0 mt-1 text-muted text-small-2 text-start'>
                                                            {currencyFormat.format(Math.round(ePrice[product.id] / 10))}
                                                            &nbsp;
                                                            تومان
                                                        </div>
                                                    </td>
                                                    <td>

                                                        <input
                                                            type="number"
                                                            value={bPrice[product.id] || ''} // هندل کردن حالت undefined
                                                            onChange={(e) => {
                                                                const newValue = e.target.value;
                                                                setBPrice(prev => ({...prev, [product.id]: newValue}));

                                                                const newValue2 = Math.round(e.target.value / product.in_box_count);

                                                                setEPrice(prev => ({...prev, [product.id]: newValue2}));
                                                            }}
                                                            onBlur={(e) => {
                                                                if (parseInt(e.target.value) !== product.vendor_price.price)
                                                                onUpdatePrice(product.id, "B", e.target.value);


                                                                const newValue2 = Math.round(e.target.value / product.in_box_count);
                                                                onUpdatePrice(product.id, "E", newValue2)
                                                            }}
                                                            className='w-100 rounded  border-0 py-2 text-start ltr '
                                                        />
                                                        <div className='p-0 mt-1 text-muted text-small-2 text-start'>
                                                            {currencyFormat.format(Math.round(bPrice[product.id] / 10))}
                                                            &nbsp;
                                                            تومان
                                                        </div>
                                                    </td>


                                                </tr>
                                            )} )
                                    }

                                    </tbody>
                                </table>

                            </div>

                        </div>

                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default VendorProductsBatchEdit;